import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const ToggleOrdersFilter: Handler = props => {
    props.dispatch({
        type: "Custom/DiscrepancyHistory/ToggleFiltersOpen",
    });
};

export const chain = [ToggleOrdersFilter];

const DiscrepancytoggleFiltersOpen = createHandlerChainRunnerOptionalParameter(
    chain,
    {},
    "DiscrepancytoggleFiltersOpen",
);
export default DiscrepancytoggleFiltersOpen;
